import PropTypes from "prop-types"
import React from "react"

import { displayText } from "src/components/SelectPaymentMethod/payment_method_helpers"

const paymentMethodCopy = (acceptedPaymentMethods, allowDirectPayment) => {
  const parts = acceptedPaymentMethods.map(displayText)
  if (allowDirectPayment) parts.push("Cash or Check")
  return parts.join(" or ")
}

const Requirement = ({ icon, title, children }) => (
  <div className="flex items-start space-x-3">
    <i className={`${icon} mt-1 text-teal-600`} />
    <div className="flex flex-col">
      <span className="font-semibold">{title}</span>
      <span className="text-gray-700">{children}</span>
    </div>
  </div>
)

Requirement.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

const RequirementsPanel = ({
  insuranceRequired = false,
  registrationRequired = false,
  acceptedPaymentMethods = [],
  allowDirectPayment = false,
}) => (
  <div>
    <h4 className="mb-2 mt-0 font-semibold text-gray-700">
      Make Sure You Have
    </h4>
    <div className="flex flex-col space-y-4 rounded-lg border border-gray-300 px-4 py-6">
      {insuranceRequired && (
        <Requirement icon="fa-solid fa-circle-check" title="Proof of Insurance">
          Proof of liability coverage for your vessel
        </Requirement>
      )}
      {registrationRequired && (
        <Requirement icon="fa-solid fa-circle-check" title="Boat Registration">
          Your current vessel registration
        </Requirement>
      )}
      <Requirement icon="fa-solid fa-credit-card" title="Payment Method">
        {paymentMethodCopy(acceptedPaymentMethods, allowDirectPayment)}
      </Requirement>
    </div>
  </div>
)

RequirementsPanel.propTypes = {
  insuranceRequired: PropTypes.bool,
  registrationRequired: PropTypes.bool,
  acceptedPaymentMethods: PropTypes.arrayOf(PropTypes.string),
  allowDirectPayment: PropTypes.bool,
}

export default RequirementsPanel
